import { useState, useContext } from 'react';
import { RefreshCw } from 'lucide-react';
import AuthContext from '../../../../../../../context/AuthContext';
import { useToast } from '../../../../../../../context/ToastContext';
import ConfirmationModal from '../../../../../../../components/ConfirmationModal';
import auditProgramService from '../../../../../../../services/audit_services/auditProgramService';

export default function UnachieveProgramModal({ isOpen, onClose, programId, programTitle, onSuccess }) {
  const { authTokens } = useContext(AuthContext);
  const { showError, showSuccess } = useToast();
  const [loading, setLoading] = useState(false);

  const handleUnachieve = async () => {
    setLoading(true);
    
    try {
      const result = await auditProgramService.unachieveAuditProgram(authTokens.access, programId);
      
      if (result.success) {
        showSuccess('Programme désarchivé avec succès');
        onSuccess();
        onClose();
      } else {
        showError(result.error || 'Erreur lors du désarchivage du programme');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error unachieving audit program:', error);
      showError('Erreur lors du désarchivage du programme');
      setLoading(false);
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleUnachieve}
      title="Désarchiver le programme"
      message={`Êtes-vous sûr de vouloir retirer le statut archivé du programme d'audit "${programTitle}" ? Cela changera le statut du programme en ouvert. Note : Les plans d'audit conserveront leur statut actuel.`}
      confirmText={loading ? 'Désarchivage...' : 'Désarchiver'}
      confirmButtonClass="bg-gray-600 hover:bg-gray-700"
      icon={<RefreshCw className="h-6 w-6 text-gray-600" />}
      loading={loading}
    />
  );
}